import script from "./PaymentBlock.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaymentBlock.vue?vue&type=script&setup=true&lang=ts"

import "./PaymentBlock.vue?vue&type=style&index=0&id=766c9c7e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-766c9c7e"]])

export default __exports__